import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	organizationsListBreadcrumb: {
		id: 'fastshift.organization-details-page.parent-page-breadcrumb',
		defaultMessage: 'Organizations',
		description: 'Breadcrumb for organizations page, the parent page of organization details page',
	},
	loadingLabel: {
		id: 'fastshift.organization-details-page.loading-label',
		defaultMessage: 'Loading organization details',
		description: 'Accessible label for the organization details page loading indicator.',
	},
});
